import React from 'react';
import { Box, Typography } from '@mui/material';
import { CWY_COLORS } from '../../theme/colors';

export const appPanelShellSx = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  minHeight: 0,
  border: `1px solid ${CWY_COLORS.border}`,
  borderRadius: '8px',
  overflow: 'hidden',
  bgcolor: 'var(--cwy-cardBg, #fff)',
} as const;

interface AppPanelShellProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export const AppPanelShell: React.FC<AppPanelShellProps> = ({
  title,
  subtitle,
  children,
  footer,
}) => (
  <Box sx={appPanelShellSx}>
    <Box
      sx={{
        px: 2,
        py: 1.5,
        borderBottom: `1px solid ${CWY_COLORS.border}`,
        flexShrink: 0,
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.125rem' }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography sx={{ fontSize: '0.875rem', color: CWY_COLORS.textSecondary, mt: 0.25 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    <Box
      sx={{
        flex: 1,
        overflow: 'auto',
        minHeight: 0,
        WebkitOverflowScrolling: 'touch',
      }}
    >
      {children}
    </Box>
    {footer && (
      <Box
        sx={{
          flexShrink: 0,
          px: 2,
          py: 1.5,
          borderTop: `1px solid ${CWY_COLORS.border}`,
          bgcolor: 'var(--cwy-cardBg, #fff)',
        }}
      >
        {footer}
      </Box>
    )}
  </Box>
);
